import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import styled from 'styled-components';
import CampaignForm from '~/campaign-form';
import ViewCampaign from '~/campaign';
import ListCampaigns from '~/campaigns-list';
import {
  campaignTab,
  campaignsPage,
  campaignCreate,
  campaignEdit,
  calendarMonth,
  calendarWeek,
  calendarPage,
  contentPage,
  blueprintsPage,
} from '~/routes';
import PageWithSidebarWrapper from '~/app-pages/components/PageWithSidebarWrapper';
import { ContentApp } from '~/content';
import Calendar from '../../../calendar';
import Blueprints from '../../../blueprints';

const ScrollableContainer = styled.div`
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 1px;
`;

const PagesWithSidebar = () => {
  // Class names we need to append so they can be targeted by Pendo.
  const enabledFeatures = ['content-generation-enabled'];

  return (
    <PageWithSidebarWrapper className={enabledFeatures.join(' ')}>
      <ScrollableContainer>
        <Switch>
          <Route path={campaignCreate.route} component={CampaignForm} />
          <Route
            path={campaignEdit.route}
            // eslint-disable-next-line react/jsx-props-no-spreading
            render={(props) => <CampaignForm {...props} editMode />}
          />
          <Route path={campaignTab.route} component={ViewCampaign} />
          <Route path={campaignsPage.route} component={ListCampaigns} />
          <Route path={calendarMonth.route} component={Calendar} />
          <Route path={calendarWeek.route} component={Calendar} />
          <Route path={contentPage.route} component={ContentApp} />
          <Route path={blueprintsPage.route} component={Blueprints} />
          <Redirect from={calendarPage.route} to={calendarWeek.route} />
        </Switch>
      </ScrollableContainer>
    </PageWithSidebarWrapper>
  );
};

export default PagesWithSidebar;
